<form [formGroup]="attributeFormGroup" class="no-field-space">

    <sc-flex vertical stretchContent>

        <ng-container *ngFor="let attribute of articleType?.basicArticleDefinition?.attributes; let i = index">
            <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
            <mat-form-field appearance="fill" *ngIf="'STRING' == attribute.articleTypeAttribute?.type">
                <mat-label><app-dictionary-entry-label
                        [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
                <input matInput [formControlName]="'attr-'+attribute.attributeId"
                    [required]="attribute.articleTypeAttribute.mandatory === true">
            </mat-form-field>
            <mat-form-field appearance="fill" *ngIf="'TEXT' == attribute.articleTypeAttribute?.type">
                <mat-label><app-dictionary-entry-label
                        [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
                <input matInput [formControlName]="'attr-'+attribute.attributeId"
                    [required]="attribute.articleTypeAttribute.mandatory === true">
            </mat-form-field>
            <mat-form-field appearance="fill" *ngIf="'NUMBER' == attribute.articleTypeAttribute?.type">
                <mat-label><app-dictionary-entry-label
                        [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
                <input matInput type="number" [formControlName]="'attr-'+attribute.attributeId"
                    [required]="attribute.articleTypeAttribute.mandatory === true">
            </mat-form-field>
            <mat-form-field appearance="fill" *ngIf="'DECIMAL' == attribute.articleTypeAttribute?.type">
                <mat-label><app-dictionary-entry-label
                        [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
                <input matInput type="number" [formControlName]="'attr-'+attribute.attributeId"
                    [required]="attribute.articleTypeAttribute.mandatory === true">
            </mat-form-field>
            <mat-form-field appearance="fill" *ngIf="'LOOKUP' == attribute.articleTypeAttribute?.type">
                <mat-label><app-dictionary-entry-label
                        [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
                <mat-select [formControlName]="'attr-'+attribute.attributeId"
                    [required]="attribute.articleTypeAttribute.mandatory === true">
                    <mat-option *ngFor="let value of attribute.articleTypeAttribute.values" [value]="value.id+''">
                        {{ value.value }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-checkbox *ngIf="'BOOLEAN' == attribute.articleTypeAttribute?.type"
                [formControlName]="''+attribute.attributeId"
                [required]="attribute.articleTypeAttribute.mandatory === true">
                <app-dictionary-entry-label [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label>
            </mat-checkbox>
        </ng-container>
    </sc-flex>
</form>
